import axios from 'axios';

const loadMoreNews = () => {
    const loadMoreNewsButton = document.querySelector('#loadMoreNews');

    if (typeof loadMoreNewsButton !== 'undefined' && loadMoreNewsButton !== null) {
        loadMoreNewsButton.addEventListener('click', () => {
            const newsList = document.querySelector('.newsoverview');
            const categorySelect = document.querySelector('#newscat-select');
            let newsCategory = categorySelect.options[categorySelect.selectedIndex].value;

            let params = new URLSearchParams();
            params.append('action', 'load_more_news');
            params.append('current_page', newsList.dataset.page);
            params.append('max_pages', newsList.dataset.maxpages);
            params.append('category_name', newsCategory);

            axios
                .post('/wp/wp-admin/admin-ajax.php', params)
                .then(res => {
                    let newcontainer = newsList.querySelector('.newslistitems__container');
                    newcontainer.innerHTML += res.data.data;

                    newsList.dataset.page++;

                    let getUrl = window.location;
                    let baseUrl = getUrl.protocol + "//" + getUrl.host;
                    window.history.pushState({path: baseUrl + window.location.pathname}, '', baseUrl + window.location.pathname + '?page=' + newsList.dataset.page);

                    if (parseInt(newsList.dataset.page) >= parseInt(newsList.dataset.maxpages)) {
                        console.log('max pages reached');
                        loadMoreNewsButton.classList.add('hidden');
                        loadMoreNewsButton.disabled = true;
                    } else {
                        loadMoreNewsButton.classList.remove('hidden');
                        loadMoreNewsButton.disabled = false;
                    }
                });
        });
    }
}

export default loadMoreNews;
